import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";

export const SeoHead = () => {
  const { metaTitle, metaDescription } = useSelector(
    (state) => state.metaTagsSlice,
  );

  return (
    <Helmet defer={false}>
      <title>{metaTitle}</title>

      <meta name="description" content={metaDescription} />
    </Helmet>
  );
};
